import React, { useEffect } from "react";
import Helmet from "react-helmet";
import styled from "styled-components";
import "../../fonts/fonts.css";
import "./variables.scss";
import "./reset.scss";
import Nav from "./Nav";
import Footer from "./Footer";
import { ModalProvider } from "../modal/ModalContext";
import Modal from "../modal/Modal";


const StyledOuter = styled.div`
  background-color: var(--theme-background-dark);
  color: var(--theme-text-against-dark);
  //contain: paint;
  /*
  background-size: 1rem 1rem;
  background-image: radial-gradient(circle, rgba(255,255,255,0.05) 1px, rgba(0, 0, 0, 0) 1px);
  */
`;

const StyledInner = styled.div`
  position: relative;
  padding: 0 var(--gutter);
  margin: 0 auto;
  max-width: var(--max-width);
  @media ( min-width: 60em ) {
    //margin-left: 8em;
  }
  /*&::before,
  &::after {
    content: "";
    position: absolute;
    top: 0;
    bottom: 0;
    z-index: 10;
    border: 0.5px solid currentColor;
    opacity: 0.04;
    mix-blend-mode: difference;
  }
  @media ( min-width: 60em ) {
    &::before {
      left: calc(6.8125em + var(--gutter));
    }
    &::after {
      right: calc(6.8125em + var(--gutter));
    }
  }*/
`;

const registerTouchables = () => {
  const touchables = document.querySelectorAll('button, button, a[href], label');
  let touchablesLength = touchables.length;


  while ( touchablesLength-- ) {
    touchables[touchablesLength].addEventListener('touchstart', () => {}, {passive: true});
    touchables[touchablesLength].addEventListener('touchend', () => {}, {passive: true});
  }
};

const adjustOutsideLinks = () => {
  const anchors = document.querySelectorAll('a[href]');
  let anchorsLength = anchors.length;


  while ( anchorsLength-- ) {
    if ( anchors[anchorsLength].hostname !== window.location.hostname ) {
      anchors[anchorsLength].target = '_blank';
      anchors[anchorsLength].rel = 'noopener noreferrer';
    }
  }
}
const Layout = ({ children, pathname }) => {

  useEffect(() => {

    document.getElementsByTagName( 'html' )[0].classList.add(`js`);

    registerTouchables();
    adjustOutsideLinks();

    const canHover = !(matchMedia(`(hover: none)`).matches)
    if ( canHover ) {
      document.getElementsByTagName( 'html' )[0].classList.add(`can-hover`);
    }
  });


  return (
    <ModalProvider>
      {/*<Nav />*/}
      <StyledOuter>
        <StyledInner>
          <Helmet>
            <meta name="viewport" content="width=device-width, initial-scale=1.0, viewport-fit=cover" />
            <meta name="theme-color" content="#000000" />
          </Helmet>
            {children}
          {/*<Footer />*/}
        </StyledInner>
      </StyledOuter>
      {/*<Modal />*/}
    </ModalProvider>
  );
};

export default Layout;